export default __webpack_public_path__ + "static/media/4.8e026bc6.png";